export default {
    'American Viticultural Area': 'AVA',
    Appellation: 'Appellation',
    "Appellation d'origine contrôlée": 'AOC',
    "Appellation d'origine contrôllée": 'AOC',
    "Appellation d'origine protégée": 'AOP',
    'Beschermde Geografische Aanduiding': 'PGI',
    'Beschermde oorsprongsbenaming': 'PDO',
    'Chráněné označení původu': 'PDO',
    'Chránené Označenie Pôvodu': 'PDO',
    'Chráněné zeměpisné označení': 'PGI',
    'D.O.C.': 'PDO',
    'Denominação de Origem': 'PDO',
    'Denominação de Origem Protegida': 'PDO',
    'Denominación de Origen': 'PDO',
    'Denominación de Origen Calificada': 'PDO',
    'Denominación de Origen Protegida': 'PDO',
    'Denominazione di origine controllata': 'PDO',
    'Denominazione di origine controllata e garantita': 'PDO',
    District: 'District',
    District: 'District',
    'Districtus Austriae Controllatus': 'PDO',
    'Geografska oznaka': 'PGI',
    'Geographical Indication': 'GI',
    'Geschützte geografische Angabe': 'PGI',
    'Geschützte Ursprungsbezeichnung': 'PDO',
    'Indicação de Procedência': 'Indication of Origin',
    'Indicação Geográfica Protegida': 'PGI',
    'Indicación Geográfica': 'IG',
    'Indicație geografică protejată': 'PGI',
    'Indication géographique protégée': 'PGI',
    'Indicazione geografica tipica': 'PGI',
    'Mark of Origin': 'Mark of Origin',
    Microzone: 'PDO',
    'Oltalom alatt álló eredetmegjelölés': 'PDO',
    'Oltalom alatt álló földrajzi jelzés': 'PGI',
    'Oznaka kontrolisanog geografskog porekla': 'GI',
    PDO: 'PDO',
    Produktionsgebiet: 'Produktionsgebiet',
    'Protected Designation of Origin': 'PDO',
    'Protected geographical indication': 'PGI',
    'Pегионално вино': 'PGI',
    Region: 'Region',
    Región: 'Región',
    Région: 'Region',
    Regiony: 'Region',
    Rejon: 'Rejon',
    Subregion: 'Subregion',
    Subregión: 'Subregión',
    Subzona: 'Subzona',
    'Treguesi gjeografik': 'GI',
    'Treguesi i origjinës gjeografike të kontrolluar': 'GI',
    "Vin d'appellation d'origine garantie": 'VAOG',
    'Vino de Calidad': 'PDO',
    'Vino de la Tierra': 'IGP',
    'Vino de Pago': 'PDO',
    Vinogorje: 'Subregion',
    Ward: 'Ward',
    Weinbaugebiet: 'PDO',
    Weinbauregion: 'PGI',
    'Zaščitena geografska označba': 'PGI',
    'Zaščitena označba porekla': 'PDO',
    'Zaštićena oznaka izvornosti': 'PDO',
    Zona: 'Zona',
    Zone: 'Zone',
    'Προστατευόμενη γεωγραφική ένδειξη': 'PGI',
    'Προστατευόμενη Ονομασία Προέλευσης': 'PDO',
    'Гарантирано и контролиранонаименование за произход': 'PDO',
    'Гарантирано наименование запроизход': 'PDO',
    Терруары: 'Region',
    'Vinogradarski rejon': 'GI',
    'Vinogradarski region': 'GI',
};
